import { render } from "./natureEventClub.vue?vue&type=template&id=4849ff6a"
import script from "./natureEventClub.vue?vue&type=script&lang=js"
export * from "./natureEventClub.vue?vue&type=script&lang=js"

import "./natureEventClub.vue?vue&type=style&index=0&id=4849ff6a&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__